// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAENgbifUvwRPSnpnBWPjYbOFyDvoZF5lI",
  authDomain: "universiti-tekno-1581783266917.firebaseapp.com",
  databaseURL: "https://universiti-tekno-1581783266917.firebaseio.com",
  projectId: "universiti-tekno-1581783266917",
  storageBucket: "universiti-tekno-1581783266917.appspot.com",
  messagingSenderId: "260902467644",
  appId: "1:260902467644:web:98053b55e4421ea6daeb39",
  measurementId: "G-SNQ6L86M6W"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Enable offline persistence so Firestore can serve cached data
// when the client is temporarily offline or the connection is slow.
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    // Multiple tabs open — persistence only works in one tab at a time
    console.warn('Firestore persistence unavailable: multiple tabs open.');
  } else if (err.code === 'unimplemented') {
    // Browser does not support IndexedDB
    console.warn('Firestore persistence not supported in this browser.');
  }
});

export { app, db };